import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {msg, rd, type_modal, type_modal_icon} from "../../vars/rd";
import {$shutils} from "../../libs/snnh/snnh";
import {$, jsi} from "../../index";
import {modalShow} from "../../libs/redux/actions/modal";

class Notice extends Component {
    constructor(props) {
        super(props);

        this.msg = msg();
        this.history = props.history;

        /** @type {DaoBBS[]} */
        const items = rd.main.bbs || [];
        const id = Number(props.match.params.id);
        let bbs = null;
        if(id) {
            items.forEach(_bbs => {
                if(_bbs.bbsid === id) bbs = _bbs;
            });
        }
        /**
         *
         * @type {{items: DaoBBS[], id: number, bbs: null|DaoBBS}}
         */
        this.state = { items, id, bbs };
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * @returns {DaoBBS[]}
     */
    get bbs() {
        return this.state.items || [];
    }

    setNoticeRef(ref) {
        this.noticeRef = ref;
    }

    isMobileOrTablet() {
        return window.innerWidth <= 1023;
    }

    /**
     * @param bbs {DaoBBS}
     */
    detail(bbs) {
        this.setState({id: bbs.bbsid, bbs});

        if (!this.isMobileOrTablet()) return;
        if(this.noticeRef) {
            $(this.noticeRef).toggleClass("open");
        }
    }

    /**
     * @param file {DaoBBSFile}
     */
    async download(file) {
        if (file && file.url) {
            this.dispatch(
                modalShow(
                    type_modal.confirm,
                    {
                        icon: type_modal_icon.check,
                        header: this.msg.download,
                        message: `${file.filename} ${this.msg.confirm_download}`,
                    },
                    async (rs) => {
                        if (rs) {
                            jsi.jsi_download(file.url, file.filename);
                        }
                    }
                )
            );
        }
    }

    back() {
        if(this.state.bbs) {
            this.setState({bbs: null});
            if (!this.isMobileOrTablet()) return;
            if(this.noticeRef) {
                $(this.noticeRef).removeClass("open");
            }
        } else {
            if(this.history) {
                this.history.goBack();
            }
        }
    }

    render() {
        return (
            <div className="notice" ref={(ref) => this.setNoticeRef(ref)}>
                <div className="notice-left">
                    <h2>
                        {/*<PageBack />*/}
                        {/* 버튼 이벤트를 변형해야 해서 분리함 */}
                        <span className="back-wrap" onClick={() => this.back()}>
                            <img src="/images/icon-back.png" alt={'이전'}/>
                        </span>
                        공지사항 <span className="new-num">{this.bbs.length}</span>
                    </h2>
                    <div className="notice-list">
                        {
                            this.bbs.length ?
                                this.bbs.map((bbs, index) => {
                                    bbs.selected = Number(bbs.bbsid) === this.state.id;
                                    return (
                                        <div className="item new" key={index} onClick={() => this.detail(bbs)}>
                                            <div className="title">
                                                { bbs.selected ? <span className="current">현재글</span> : null }
                                                [{bbs.category_str}] {bbs.title}
                                            </div>
                                            <div className="date">{bbs.date_str} ({bbs.week_str})</div>
                                        </div>
                                    );
                                }) :
                                <div></div>
                        }
                    </div>
                </div>
                <div className="notice-right">
                    {
                        this.state.bbs ?
                            <div className="notice-view">
                                <div className="title">
                                    <h2>[{this.state.bbs.category_str}] {this.state.bbs.title}</h2>
                                    <div className="date">{this.state.bbs.date_str} ({this.state.bbs.week_str})</div>
                                    {
                                        this.state.bbs.brand ?
                                            <div className="name">
                                                <span><img src={this.state.bbs.brand_image} alt={this.state.bbs.brand}/></span> {this.state.bbs.brand}
                                            </div> : null
                                    }
                                </div>
                                {
                                    this.state.bbs.files.length ?
                                        <div className="file">
                                            {
                                                this.state.bbs.files.map((file, i) => {
                                                    return (
                                                        <div className="item" key={i}>
                                                            <img src="/images/icon-file.png" alt={file.filename} />
                                                            {file.filename}
                                                            <span>{$shutils.filesize(file.filesize)}</span>
                                                            <div className="download" onClick={() => this.download(file)}><img src="/images/icon-download.png" alt={`${file.filename} 다운로드`} /></div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div> : null
                                }

                                <div className="text"
                                     dangerouslySetInnerHTML={{__html: $shutils.nl2br(this.state.bbs.content || '')}}/>
                            </div> :
                            <div className="no-data">
                                <img src="/images/img-notice.png" alt={'정보없음'}/>
                                <span>왼쪽의 목록에서<br/>새로운 소식을 확인하세요.</span>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(Notice));


// WEBPACK FOOTER //
// ./src/pages/notice/index.jsx